var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-visual"
  }, [_c('main-visual-video'), _c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "main-visual__text"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/visual/logo.svg",
      "alt": "SAGE LAW",
      "eager": "",
      "data-aos": "fade-up",
      "data-aos-delay": "800"
    }
  })]), _c('p', {
    staticClass: "subtitle"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/visual/subtitle.svg",
      "alt": "CORPORATE ADVISORY & DISPUTES",
      "eager": "",
      "data-aos": "fade-up",
      "data-aos-delay": "1100"
    }
  })])])]), _c('main-visual-scrolldown')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }